import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import PdfFormPreview from "../preview-form/PdfFormPreview";

const ModalPreview = ({isModalOpen, handleModalClose, isEditable}) => {
    return (
        <Modal open={isModalOpen} onClose={handleModalClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <div className="customize-modal preview-form">
                <div className="modal-head">
                    <h2>{isEditable ? "Modify Form" : "Preview Form"}</h2>
                    <IconButton className="close-modal-btn p-0" onClick={handleModalClose}>
                        <HighlightOffIcon/>
                    </IconButton>
                </div>
                <div className="modal-body-content">
                    <PdfFormPreview/>
                </div>
                {isEditable && (
                    <div className="modal-foot">
                        <Button type="button" className="btn-theme" onClick={handleModalClose}>Save as Draft</Button>
                        <Button type="button" className="btn-success ms-2" onClick={handleModalClose}>Complete</Button>
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default ModalPreview;